/* eslint-disable import/prefer-default-export */
import React from 'react';
import AgentCell from './components/AgentCell';
import ToolCell from './components/ToolCell';
import StatusCell from './components/StatusCell';
import SelectedCell from './components/SelectedCell';
import WorkspaceCell from './components/WorkspacesCell';
import DateFormatter from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/Date';

export const getColumns = (themeStyles, show) => {
  return [
    {
      Header: () => <SelectedCell isHeader disabled={ show } />,
      id: 'selected',
      accessor: 'selected',
      show: true,
      sortable: false,
      resizable: false,
      maxWidth: 55,
      minWidth: 55,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      Cell: (rowInfo) => <SelectedCell rowInfo={ rowInfo } disabled={ show } />
    },
    {
      Header: 'Agent',
      accessor: 'agent_name',
      id: 'agent_name',
      maxWidth: 147,
      minWidth: 147,
      show: true,
      sortable: false,
      Cell: (rowInfo) => <AgentCell rowInfo={ rowInfo } />
    },
    {
      Header: 'Tool',
      accessor: 'tool',
      id: 'tool',
      show: true,
      sortable: false,
      maxWidth: 104,
      minWidth: 104,
      Cell: ({ value }) => <ToolCell value={ value } />
    },
    {
      Header: 'Start',
      accessor: 'create_date',
      id: 'create_date',
      show: true,
      sortable: true,
      maxWidth: 200,
      minWidth: 200,
      Cell: ({ value }) => <DateFormatter date={ value } />
    },
    {
      Header: 'Status',
      accessor: 'status',
      id: 'status',
      show: true,
      sortable: false,
      maxWidth: 102,
      minWidth: 102,
      Cell: (rowInfo) => <StatusCell rowInfo={ rowInfo } />
    },
    {
      Header: 'Category',
      accessor: 'category',
      id: 'category',
      show: true,
      sortable: false,
      maxWidth: 270,
      minWidth: 270,
      Cell: ({ original, value }) => <div style={ { color: '#90a9c0', fontSize: '14.5px', cursor: 'pointer' } } title={ value }>{value}</div>
    },
    {
      Header: 'End',
      accessor: 'update_date',
      id: 'update_date',
      show: true,
      sortable: false,
      maxWidth: 115,
      minWidth: 115,
      Cell: ({ value }) => <DateFormatter date={ value } />
    },
    {
      Header: 'Triggered By',
      accessor: 'triggered_by',
      id: 'triggered_by',
      show: true,
      sortable: true,
      maxWidth: 109,
      minWidth: 109,
      Cell: ({ value }) => <div style={ { color: '#90a9c0', fontSize: '14.5px', cursor: 'pointer' } } title={ value }>{value}</div>
    },
    {
      Header: 'Workspaces',
      accessor: 'parameters_data.workspaces_commands',
      id: 'workspaces',
      show: true,
      sortable: false,
      Cell: ({ value }) => <WorkspaceCell data={ value } />
    }
  ];
};
